<template>
  <v-row
    class="msg"
  >
    <v-textarea
      id="message"
      v-model="messageText"
      rows="1"
      :class="[sender ? 'sender' : 'receiver']"
      outlined
      readonly
      auto-grow
      :persistent-hint="true"
      :hint="messageInfo"
      :color="senderColor(sender)"
    />
  </v-row>
</template>

<script>
import moment from "moment";

export default {
  name: "Message",
  props: {
    messageText: {
      type: String,
      default: ""
    },
    sender: Boolean,
    timestamp: {
      type: String,
      default: ""
    }, // String formatted to Date by moment()
    sendername: {
      type: String,
      default: ""
    }
  },
  computed: {
    messageTimestamp() {
      let format = "MMMM Do YYYY, h:mm a";
      return moment(this.timestamp)
        .local()
        .format(format);
    },
    messageInfo() {
      return this.sendername + "\n" + this.messageTimestamp
    }
  },
  methods: {
    senderColor(sender) {
      return sender ? "#64B5F6" : "#BDBDBD";
    },
  }
};
</script>

<style>
.sender {
  left: 105% !important;
  color: #64B5F6 !important;
  border-color: #64B5F6 !important;
}
.receiver {
  left: 5% !important;
  color: #BDBDBD !important;
  border-color: #BDBDBD !important;
}
.msg .v-input__slot {
  width: 100% !important;
  border-radius: 25px !important;
}
#message {
  margin: 2%;
}
@media (min-width: 320px) and (max-width: 1023px) {
  .sender {
    left: 37.5% !important;
  }
  .receiver {
    left: 0% !important;
  }
}

.receiver fieldset {
  border-color: #BDBDBD !important;
}

.sender fieldset {
  border-color: #64B5F6 !important;
}
</style>
